// @flow
import { ConfigurationsActionTypes } from './constants';

type ConfigurationsAction = { type: string, payload: {} | string };

// common success
export const configurationsApiResponseSuccess = (actionType: string, data: any): ConfigurationsAction => ({
    type: ConfigurationsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});
// common error
export const configurationsApiResponseError = (actionType: string, error: string): ConfigurationsAction => ({
    type: ConfigurationsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const getConfiguration = (configurationId: string): ConfigurationsAction => ({
    type: ConfigurationsActionTypes.GET_CONFIGURATION,
    payload: { configurationId },
});

export const updateConfiguration = (configuration: any): ConfigurationsAction => ({
    type: ConfigurationsActionTypes.UPDATE_CONFIGURATION,
    payload: configuration
})

export const resetBasic = (): ConfigurationsAction => ({
    type: ConfigurationsActionTypes.RESET_BASIC,
    payload: {},
});

export const resetConfigurations = (): ConfigurationsAction => ({
    type: ConfigurationsActionTypes.RESET,
    payload: {},
});

